import React from 'react';
import { tagMeta } from '../tagMeta';
import { Badge } from 'components/common';

// Cell renderer for tags
const TagsRenderer = (params) => {
  if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
    return <span className="tw-text-slate-500">-</span>;
  }
  return (
    <div className="tw-flex tw-flex-wrap tw-gap-1 tw-text-sm tw-my-2">
      {params.value.map((tag, idx) => {
        // Safety check: ensure tag is a string or primitive
        const tagText = typeof tag === 'object' ? JSON.stringify(tag) : String(tag);
        const { Icon, color } = tagMeta(tagText);
        return (
          <Badge key={idx} variant="primary" size="sm" className="tw-inline-flex tw-items-center tw-gap-1">
            <Icon size={11} style={{ color }} />{tagText}
          </Badge>
        );
      })}
    </div>
  );
};

export default TagsRenderer;
